import request from '@/utils/request';
//操作日志列表
export function getHandleList(param) {
  return request('/decision/variable-input/log', {
    method: 'GET',
    params: param,
  });
}

//新增规则管理列表
export function addRuleManaList(values) {
  return request('/decision/rule', {
    method: 'POST',
    data: values,
  });
}
//编辑规则管理列表
export function editRuleManaList(values) {
  const { parentId } = values || {};
  values['parentId'] = null;
  return request(`/decision/rule/${parentId}`, {
    method: 'PUT',
    data: values,
  });
}
//删除规则管理列表
export function deleteRuleManaList(values) {
  const { id } = values || {};
  return request(`/decision/rule/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}
